module.exports = __webpack_public_path__ + "img/10ne.933bb36a.svg";